import WboPersistenceProvider from '@/components/common/ed-board/ed-board-tools/wbo-client/interfaces/wbo-persistence-provider.interface';
declare const window: any;

export default class WboLocalFilesystemPersistenceProvider extends WboPersistenceProvider {
    private readonly electronAPI = window.electronAPI;

    constructor(boardName: string, username: string) {
        super(boardName, username)
    }

    async saveDataToStorage(fileName : string, data : any): Promise<void>{
        await window.electronAPI.saveWboFile(fileName, data)
    }
    async readDataFromStorage(fileName : string): Promise<any>{
        return await this.electronAPI.getWboFile(fileName);
    }
    async deleteFromStorage(fileName : string): Promise<void>{
        await window.electronAPI.deleteWboFile(fileName);
    }
}